import { useEffect, useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import {
    fetchVoicemailSettings,
    updateVoicemailSettings,
} from 'flow/actions/voicemail-actions';
import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import SettingSelectableItem from 'flow/components/ui-components/SettingSelectableItem';
import useAppContext from 'flow/hooks/useAppContext';
import useVoicemail from 'flow/hooks/useVoicemail';
import { routes } from 'flow/types/routes';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { generatePath } from 'flow/utils/router-utils';

const SettingsVoicemailRedialType = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { i18next } = useAppContext();

    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();
    const [redialType, setRedialType] = useState('landline');
    const { voicemailSettings } = useVoicemail(extensionKey);

    useEffect(() => {
        if (!voicemailSettings) {
            dispatch(fetchVoicemailSettings(extensionKey));
        } else {
            setRedialType(voicemailSettings.get('redialType'));
        }
    }, [extensionKey]);

    const handleBack = () =>
        history.push(
            generatePath(routes['settings.voicemail.alternatives'], {
                extensionKey,
            }),
        );
    const handleChange = (selected: string) => {
        setRedialType(selected);
        dispatch(
            updateVoicemailSettings(extensionKey, {
                key: voicemailSettings.get('key'),
                redialType: selected,
            }),
        );
        handleBack();
    };

    if (!voicemailSettings) {
        return <Loading />;
    }

    return (
        <Page header="settings.voicemail_alt.callback" onClickBack={handleBack}>
            <SettingSelectableItem
                value="landline"
                onClick={handleChange}
                selected={redialType}
            >
                {i18next.t('settings.voicemail_alt.landline')}
            </SettingSelectableItem>

            <SettingSelectableItem
                value="mobile_and_landline"
                onClick={handleChange}
                selected={redialType}
            >
                {i18next.t('settings.voicemail_alt.mobile_and_landline')}
            </SettingSelectableItem>

            <SettingSelectableItem
                value="everywhere"
                onClick={handleChange}
                selected={redialType}
            >
                {i18next.t('settings.voicemail_alt.everywhere')}
            </SettingSelectableItem>

            <SettingSelectableItem
                value="none"
                onClick={handleChange}
                selected={redialType}
            >
                {i18next.t('option.none')}
            </SettingSelectableItem>
        </Page>
    );
};

export default SettingsVoicemailRedialType;
